(() => {
  if (window.ArcticmedOfferGift) return;
  const source = 'omega-3-premium-erbjudande';
  const discountCode = 'AM-PREMIUM-GAVA-8K4N';
  const storageKey = 'arcticmed-offer-gift';
  const root = () => window.Shopify?.routes?.root || '/';
  const script = document.querySelector('script[data-am-offer-gift]');
  let active = script?.dataset.hasOfferGift === 'true';
  let held = 0;
  let timer;
  let running;
  let queued = false;
  try { active ||= sessionStorage.getItem(storageKey) === 'true'; } catch (error) {}

  const persist = value => {
    active = value;
    try {
      if (value) sessionStorage.setItem(storageKey, 'true');
      else sessionStorage.removeItem(storageKey);
    } catch (error) {}
  };
  const isGift = line => Number(line.variant_id) === 53752403755348 && line.properties?._arcticmed_offer_source === source && line.properties?._arcticmed_free_gift === 'true';
  const isParent = line => [52339822788948, 52339822887252].includes(Number(line.variant_id)) && line.properties?._arcticmed_offer_source === source && Boolean(line.selling_plan_allocation);
  const codes = cart => [...new Set([
    ...(cart.discount_codes || []).map(discount => discount.code),
    ...(cart.cart_level_discount_applications || []).filter(discount => discount.type === 'discount_code').map(discount => discount.title),
    ...cart.items.flatMap(line => (line.line_level_discount_allocations || []).filter(allocation => allocation.discount_application?.type === 'discount_code').map(allocation => allocation.discount_application.title))
  ].filter(Boolean))];

  const changes = cart => {
    const parent = cart.items.some(isParent);
    const updates = {};
    let kept = false;
    cart.items.filter(isGift).forEach(line => {
      const quantity = parent && !kept && line.final_line_price === 0 && !line.selling_plan_allocation ? 1 : 0;
      if (quantity) kept = true;
      if (quantity !== line.quantity) updates[line.key] = quantity;
    });
    const currentCodes = codes(cart);
    const removeCode = !parent && currentCodes.some(code => code.toUpperCase() === discountCode);
    return { parent, updates, ...(removeCode ? { discount: currentCodes.filter(code => code.toUpperCase() !== discountCode).join(',') } : {}) };
  };

  const request = async (path, data) => {
    const response = await fetch(`${root()}${path}`, {
      method: data ? 'POST' : 'GET', credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      ...(data ? { body: JSON.stringify(data) } : {})
    });
    if (!response.ok) throw new Error('Varukorgen kunde inte uppdateras.');
    return response.json();
  };

  const schedule = () => {
    if (!active || held) return;
    clearTimeout(timer);
    timer = setTimeout(() => sync().catch(() => {}), 150);
  };
  const sync = async () => {
    if (held || !active) return;
    clearTimeout(timer);
    if (running) { queued = true; return running; }
    running = (async () => {
      let cart = await request('cart.js');
      const next = changes(cart);
      const changed = Object.keys(next.updates).length > 0 || next.discount !== undefined;
      if (changed) cart = await request('cart/update.js', { updates: next.updates, ...(next.discount !== undefined ? { discount: next.discount } : {}) });
      persist(cart.items.some(isGift) || cart.items.some(isParent));
      if (changed) {
        if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
        else if (typeof window.wubsCartDrawerRefresh === 'function') await window.wubsCartDrawerRefresh();
        else document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
      }
      cart.items.filter(isGift).forEach(line => {
        const row = document.querySelector(`[data-wubs-item][data-key="${CSS.escape(line.key)}"]`);
        if (!row) return;
        row.setAttribute('data-am-offer-gift-line', '');
        const plus = row.querySelector('[data-wubs-qty-plus]');
        if (plus) plus.disabled = true;
      });
      return cart;
    })();
    try { return await running; }
    finally {
      running = null;
      if (queued) { queued = false; schedule(); }
    }
  };

  window.ArcticmedOfferGift = {
    source, isGift, codes, changes, sync,
    hold() { held++; clearTimeout(timer); },
    release() { held = Math.max(0, held - 1); schedule(); },
    activate() { persist(true); }
  };
  ['cart:updated', 'cart:refresh', 'wubs:cart-updated'].forEach(name => document.addEventListener(name, schedule));
  window.addEventListener('pageshow', schedule);
  document.addEventListener('click', async event => {
    const checkout = event.target.closest('[data-wubs-cd-checkout], a[href$="/checkout"], button[name="checkout"]');
    if (!checkout || !active) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout.setAttribute('aria-busy', 'true');
    try {
      await sync();
      window.location.assign(`${root()}checkout`);
    } catch (error) {
      window.location.assign(`${root()}cart`);
    } finally { checkout.removeAttribute('aria-busy'); }
  }, true);
  schedule();
})();
